import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  loadFundDetails, setProfileCategory,
  setSelectedFundTickers, resetPage
} from '../../../actions';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle, faClock } from '@fortawesome/free-solid-svg-icons';
import './FundSelect.css';
import i18n from '../../../i18n';

library.add(faMinusCircle, faPlusCircle, faClock);


class FundSelect extends Component {

  setProfileCategory(category) {
    this.props.setProfileCategory(category);
  }

  setSelectedFundTickers(ticker) {
    this.props.setSelectedFundTickers(ticker);
  }

  getDataAndClear() {
    this.props.loadFundDetails();
  }

  resetPage() {
    this.props.resetPage('divtohide');
  }

  /*Conditionally render the reset and Submit button*/
  renderButtons() {
    const {
      tickers,
      selectedFunds,
      fcBottomSelected,
      btnReset,
      btnSubmit,
    } = this.props;

    if (tickers.length > 0) {
      const selected = fcBottomSelected; /*entire bottom */
      let reset = false;
      let submit = false;
      if (selectedFunds.length > 0) {
        if (selected === 'show') {
          submit = true;
        }
        if (btnReset === 'show') {
          reset = true;
        }
        if ((btnSubmit === 'hide') && (btnReset === 'show')) {
          submit = false;
        }
      }
      return (
        <div className='selectedFundsShow'>
          {reset &&
            <button className='buttonShow' onClick={() => this.resetPage()}>{i18n.t('Select Funds / Benchmarks')}</button>
          }
          {submit &&
            <button className='buttonShow' onClick={() => this.getDataAndClear()}>{i18n.t('Done')}</button>
          }
        </div>
      );
    } else {
      return null;
    }
  }

  /* used to render Option Dropdown classified by fundCategoryTier1 */
  renderAssetAllocCategories() {
    if (this.props.tickers.length === 0) {
      return null;
    }

    // const categories = [
    //   'Benchmarks',
    //   'Equity - Domestic Dividends',
    //   'Equity - Domestic Earnings',
    //   'Equity - Domestic Quality',
    //   'Equity - Developed World ex-U.S',
    //   'Equity - Emerging/Frontier Markets',
    //   'Equity - Currency Hedged Equity',
    //   'Equity - Global/Global ex-U.S.',
    //   'Equity - Multifactor',
    // ];
    // group tickers by category ascending
    // const nestedData = group()
    //   .key(function (d) {
    //     return d.fundCategoryTier1;
    //   })
    //   .sortKeys(ascending)
    //   .entries(this.props.tickers);

    const nestedData = this.props.tickers.map(ticker => ticker.fundCategoryTier1).sort();

    // specific ordering
    const data = [...new Set(nestedData)];

    // Remove ordering for now
    // for (let x = 0; x < categories.length; x++) {
    //   for (let y = 0; y < nestedData.length; y++) {
    //     if(nestedData[y].key === categories[x]) {
    //       data.push(nestedData[y]);
    //       break;
    //     }
    //   }
    // }

    // create the drop down options
    return (
      data.map((category) => (
        <option key={category} value={category}>{category}</option>
      ))
    );
  }

  /* used to render list of FundName & FundTickers belonging to the category selected via dropdown  */
  renderAssetCatFunds() {
    const {
      selectedFunds,
      catFunds
    } = this.props;

    if (!catFunds) {
      return null;
    }

    function containsObject(obj, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].ticker === obj) {
          return true;
        }
      }
      return false;
    }

    const tickerList = catFunds.map((fund) => {
      const highlight = containsObject(fund.ticker, selectedFunds);
      return (
        <div className='col-sm-3' key={fund.ticker}>
          {/* ticker is selected so it's a minus symbol */}
          {highlight &&
            <div
              id={fund.ticker}
              className='btnDefault'
              onClick={() => this.setSelectedFundTickers(fund)}>
              {fund.fundCategoryTier1 === 'Benchmarks' &&
                <div className='btnNameBmk'>{fund.name}</div>
              }
              {fund.fundCategoryTier1 !== 'Benchmarks' &&
                <div className='btnName'>{fund.name}</div>
              }
              <div className='btnTicker'>{fund.ticker}
                &nbsp;<FontAwesomeIcon style={{ color: 'red' }} icon='minus-circle' />
              </div>
            </div>
          }
          {/* ticker isn't selected and slots are open so plus symbol */}
          {!highlight && selectedFunds.length < 4 &&
            <div
              id={fund.ticker}
              className='btnDefault'
              onClick={() => this.setSelectedFundTickers(fund)}>
              {fund.fundCategoryTier1 === 'Benchmarks' &&
                <div className='btnNameBmk'>{fund.name}</div>
              }
              {fund.fundCategoryTier1 !== 'Benchmarks' &&
                <div className='btnName'>{fund.name}</div>
              }
              <div className='btnTicker'>{fund.ticker}
                &nbsp;<FontAwesomeIcon style={{ color: '#050139' }} icon='plus-circle' />
              </div>
            </div>
          }
          {/* ticker isn't selected but slots are full so not actionable */}
          {!highlight && selectedFunds.length >= 4 &&
            <div
              id={fund.ticker}
              className='btnDefault'
              style={{ cursor: 'auto' }}>
              {fund.fundCategoryTier1 === 'Benchmarks' &&
                <div className='btnNameBmk'>{fund.name}</div>
              }
              {fund.fundCategoryTier1 !== 'Benchmarks' &&
                <div className='btnName'>{fund.name}</div>
              }
              <div className='btnTicker'>{fund.ticker}</div>
            </div>
          }
        </div>
      );
    });

    return (
      <div className='row'>
        {tickerList}
      </div>
    );
  }

  /* used to render ticker list at the top- will need to add name?*/
  renderFundsToCompare() {
    const {
      selectedFunds,
      btnReset: editButton,
    } = this.props;

    if (selectedFunds) {
      const tickerList = selectedFunds.map((fund) => {
        return (
          <div className='col-sm-3' key={fund.ticker}>
            {/* we're not in edit mode so no actions */}
            {editButton === 'show' &&
              <div
                className='btnChosen'
                style={{ cursor: 'auto' }}
              >
                {fund.fundCategoryTier1 === 'Benchmarks' &&
                  <div>
                    <div className='btnNameBmk'>{fund.name}</div>
                    <div className='btnTicker'>{fund.ticker}</div>
                  </div>
                }
                {fund.fundCategoryTier1 !== 'Benchmarks' &&
                  <div>
                    <div className='btnName'>{fund.name}</div>
                    {!fund.fundPageURL? 
                    <div className='btnTicker'>{fund.ticker}</div>
                    :
                    <div className='btnTicker'><a className='tickerLink' href={fund.fundPageURL} target='_new'>{fund.ticker}</a></div>
                    }                    
                  </div>
                }
              </div>
            }
            {/* we're editing so actionable */}
            {editButton !== 'show' &&
              <div
                className='btnChosen'
                onClick={() => this.setSelectedFundTickers(fund)}
              >
                {fund.fundCategoryTier1 === 'Benchmarks' &&
                  <div className='btnNameBmk'>{fund.name}</div>
                }
                {fund.fundCategoryTier1 !== 'Benchmarks' &&
                  <div className='btnName'>{fund.name}</div>
                }
                <div className='btnTicker'>{fund.ticker}
                  <span>&nbsp;</span>
                  <FontAwesomeIcon style={{ color: 'red' }} icon='minus-circle' />
                </div>
              </div>
            }
          </div>
        );
      });
      const emptyFunds = [];
      for (let i = selectedFunds.length + 1; i <= 4; i++) {
        emptyFunds.push(i);
      }
      const bucketList = emptyFunds.map((fund) => {
        return (
          <div className='col-sm-3' key={fund}>
            {/* we're not editing so make it trigger edit button */}
            {editButton === 'show' &&
              <div
                className='btnEmpty'
                onClick={() => this.resetPage()}
              >
                <div className='btnEmptyName'>{i18n.t('Select a Fund / Benchmark')}</div>
              </div>
            }
            {/* we're editing so just an empty slot for display */}
            {editButton !== 'show' &&
              <div className='btnEmpty' style={{ cursor: 'auto' }}>
                <div className='btnEmptyName'>{i18n.t('Fund / Benchmark')} {fund}</div>
              </div>
            }
          </div>
        );
      });

      return (
        <div className='row'>
          {tickerList}
          {bucketList}
        </div>
      );
    } else {
      return null;
    }
  }

  /**********************************************************************/
  /**********************************************************************/
  render() {
    const {
      tickers,
      selectedFunds,
      fcHideOptions,
    } = this.props;

    if (tickers) {
      return (
        <div className='fund-char-fund-select'>
          {selectedFunds && selectedFunds.length > 0 &&
            <div>
              {this.renderFundsToCompare()}
              <div className='row'>
                <div className='col-md-8'></div>
                <div className='col-md-4'>
                  {this.renderButtons()}
                </div>
              </div>
            </div>
          }
          {(!fcHideOptions || fcHideOptions === 'show') &&
            <div>
              <div className='row'>
                <div className={`selectCopy col-md-6`}>
                  {i18n.t('select-funds-gp')}
                </div>
              </div>
              <div className='row'>
                <div className={`selectCopy col-md-6`}>
                  {i18n.t('gp-callout-to-reg')} {i18n.t('please')} <a className='i18n-text' href="https://www.wisdomtree.com/registration/my-profile?redirect=https://www.wisdomtree.com/tools#fund-comparison&"> {i18n.t('register')}
                  </a> {i18n.t('or')}<a className='i18n-text' href="https://www.wisdomtree.com/sign-in?redirect=https://www.wisdomtree.com/tools#fund-comparison&"> {i18n.t('login')}</a>.
                </div>
              </div>
              <div className='row'>
                <div className={`profileCats col-md-6`}>
                  <select onChange={(event) => this.setProfileCategory(event.target.value)}>
                    <option value=''>Select a category</option>
                    {this.renderAssetAllocCategories()}
                  </select>
                </div>
              </div>
              {this.renderAssetCatFunds()}
            </div>
          }
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    selectedFunds: state.params.selectedFunds,
    fcBottomSelected: state.params.fcBottomSelected,
    catFunds: state.fundData.catFunds,
    tickers: state.fundData.tickers,
    fcHideOptions: state.fundData.fcHideOptions,
    btnReset: state.fundData.btnReset,
    btnSubmit: state.fundData.btnSubmit,
  };
}

export default connect(mapStateToProps, {
  loadFundDetails,
  setProfileCategory,
  setSelectedFundTickers,
  resetPage,
})(FundSelect);
